// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"275":"cc09ebe2","538":"f5680a87"}[chunkId] + ".css";
};